import { Route, Routes } from "react-router-dom";
import Categories from "./Categories";

export default function CategoriesRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Categories />} />
    </Routes>
  );
}